"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable operator-linebreak */
var background_1 = __importDefault(require("src/utilities/styled/background"));
var colorVariations_1 = __importDefault(require("src/utilities/styled/colorVariations"));
var variations = new Set(['muted', 'error']);
var styledTextDecoration = function (_a) {
    var textDecoration = _a.textDecoration;
    if (textDecoration === 'underline') {
        return "\n      cursor: pointer;\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    ";
    }
    if (textDecoration === 'dotted') {
        return "\n      cursor: pointer;\n      text-decoration: none;\n      border-bottom-style: dotted;\n      border-bottom-width: 1px;\n\n      &:hover {\n        text-decoration: none;\n        border-bottom-style: solid;\n        border-bottom-width: 1px;\n      }\n    ";
    }
    return '';
};
// TODO: refactor this
exports.default = (function (_a) {
    var _b, _c;
    var theme = _a.theme, hoverIndicator = _a.hoverIndicator;
    if (typeof hoverIndicator === 'boolean') {
        if (hoverIndicator) {
            return "\n        cursor: pointer;\n        text-decoration: none;\n\n        &:hover {\n          color: " + (0, colorVariations_1.default)({ theme: theme }, theme.palette.buttonColor[2]) + ";\n        }\n      ";
        }
        return '';
    }
    if (typeof hoverIndicator === 'string') {
        if (variations.has(hoverIndicator)) {
            return "\n        cursor: pointer;\n        text-decoration: none;\n\n        &:hover {\n          color: " + (0, colorVariations_1.default)((_b = { theme: theme }, _b[hoverIndicator] = true, _b), theme.palette.buttonColor[2]) + ";\n        }\n      ";
        }
        else {
            var value = styledTextDecoration({ textDecoration: hoverIndicator });
            if (value) {
                return value;
            }
        }
    }
    if (typeof hoverIndicator !== 'object') {
        return '';
    }
    if (typeof hoverIndicator === 'object') {
        var background = hoverIndicator.background, opacity = hoverIndicator.opacity, color = hoverIndicator.color, variation = hoverIndicator.variation, textDecoration = hoverIndicator.textDecoration;
        return "\n      &:hover {\n        " + (color || variations.has(variation)
            ? "color: " + (0, colorVariations_1.default)((_c = { theme: theme, color: color }, _c[variation] = true, _c), theme.palette.buttonColor[2]) + ";"
            : '') + "\n        " + (opacity && "opacity: " + opacity) + "\n        " + (0, background_1.default)({ theme: theme, background: background }) + "\n      }\n\n      " + styledTextDecoration({ textDecoration: textDecoration }) + "\n    ";
    }
    return '';
});
